module.exports = __webpack_public_path__ + "img/error.36109e6b.svg";